import { useMemo } from 'react';

import {
  getCohortBuilderPath,
  getCohortsPath,
  getProjectsBasePath,
} from '@verantos-dev/core-constants';

import { useCohortBuilderData } from './useCohortBuilderData';

export const useProjectCohortsNavigation = () => {
  const { projectId, cohortId, cohortVersionId, latestCohortVersionId } = useCohortBuilderData();

  const navigateToPath = useMemo(() => {
    if (projectId) {
      if (cohortId && cohortVersionId) {
        return getCohortBuilderPath(projectId, cohortId, cohortVersionId);
      }
      if (cohortId && latestCohortVersionId) {
        return getCohortBuilderPath(projectId, cohortId, latestCohortVersionId);
      }
      return getCohortsPath(projectId);
    }
    return getProjectsBasePath();
  }, [projectId, cohortId, cohortVersionId, latestCohortVersionId]);

  return { navigateToPath, projectId, cohortId, cohortVersionId, latestCohortVersionId };
};
